import { FacetSort } from '../../core/profiles/entities/profile-field.entity';
import { ApiStructuredQuery } from '../../core/query/entities/structured-query.entity';

export interface FacetRequest {
    Search: {
        StructuredQuery: ApiStructuredQuery;
    };
    Source?: {
        ProfileId?: string;
        CustomFacets?: string[];
    };
    Locale?: {
        Value: string;
        Restricted: boolean;
    };
    Value?: {
        Options?: Record<string, FacetValueOptions>;
        Constraints?: Record<string, FacetValueConstraint>;
    };
}

export interface TaskFacetRequest extends FacetRequest {
    Search: {
        StructuredQuery: ApiStructuredQuery;
        OnlyCompletable: boolean;
    };
}

export interface FacetValueOptions {
    SelectionType?: FacetSelectionType;
    HideEmpty?: boolean;
    Sort?: FacetSort;
    ReverseOrder?: boolean;
    DefaultNumberOfValues?: number;
    IncludeMissingValue?: boolean;
    IncludeActiveValues?: boolean;
}

export interface FacetValueConstraint {
    Prefix?: string;
    StartIndex?: number;
}

export enum FacetSelectionType {
    MUST = 'MUST',
    SHOULD = 'SHOULD'
}
